module.exports = __webpack_public_path__ + "static/media/blog_57.2255b488.webp";